import React from 'react'
import banner from "../../assets/cloud_migration/cloud_mig_banner.png";
import { TypeAnimation } from "react-type-animation";
import MovingText from "react-moving-text";
import Button from "@mui/material/Button";
import { useMediaQuery, useTheme } from "@mui/material";


const CloudConsultationBanner = () => {
    const theme = useTheme();
    return (
      <div>
       <div className="flex flex-col sm:flex-row justify-center w-full relative bg-gradient-to-r from-sky-50 to-fuchsia-400">
        <div className="w-full sm:w-1/2 md:top-1 lg:top-24 py-10 flex flex-col justify-center">
          <div className="w-full text-lg sm:text-4xl px-10 font-bold poppins-bold text-[#333e49] text-center">
              <MovingText
                type="fadeInFromBottom"
                duration="1000ms"
                delay="0s"
                direction="normal"
                timing="ease"
                iteration="1"
                fillMode="none"
              >
                Strategic Cloud Consultation for Transformative Digital Solutions
              </MovingText>
            </div>
            <div className="w-full text-sm sm:text-lg  px-10 sm:leading-[5.5rem] font-notosans text-center text-[#ff5e16] font-semibold leading-5">
              {/* Crafting Innovative Websites Tailored to Your Vision */}
  
              <MovingText
                type="fadeInFromLeft"
                duration="1000ms"
                delay="0s"
                direction="normal"
                timing="ease"
                iteration="1"
                fillMode="none"
              >
                <TypeAnimation
                  sequence={[
                    'We Experts in "Strategic Vision"',
                    1000,
                    'We Experts in "Tailored Solutions"',
                    1000,
                    'We Experts in "Seamless Migration"',
                    1000,
                    'We Experts in "Security At the Core"',
                    1000,
                    'We Experts in "Optimizing the Investment"',
                    1000,
                  ]}
                  wrapper="span"
                  speed={50}
                  style={{ fontSize: "1em", display: "inline-block" }}
                  repeat={Infinity}
                />
              </MovingText>
            </div>
            <p className="px-2 sm:px-10 mt-3 text-center">
              <Button
                size={
                  useMediaQuery(theme.breakpoints.down("sm")) ? "small" : "medium"
                }
                variant="contained"
                href="#contact"
              >
                Free Consultation
              </Button>
            </p>
          </div>
          <div className="w-full sm:w-1/2 flex justify-center">
              <img className="w-[15rem] sm:w-[30rem] animate-pulse" src={banner} />
              
          </div>
        </div>
      </div>
    );
}

export default CloudConsultationBanner